/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import type { Cart } from './Cart';
import {
    CartFromJSON,
    CartFromJSONTyped,
    CartToJSON,
} from './Cart';
import type { CustomerShort } from './CustomerShort';
import {
    CustomerShortFromJSON,
    CustomerShortFromJSONTyped,
    CustomerShortToJSON,
} from './CustomerShort';
import type { Invoice } from './Invoice';
import {
    InvoiceFromJSON,
    InvoiceFromJSONTyped,
    InvoiceToJSON,
} from './Invoice';
import type { OrderStatus } from './OrderStatus';
import {
    OrderStatusFromJSON,
    OrderStatusFromJSONTyped,
    OrderStatusToJSON,
} from './OrderStatus';
import type { TenantOrderDetails } from './TenantOrderDetails';
import {
    TenantOrderDetailsFromJSON,
    TenantOrderDetailsFromJSONTyped,
    TenantOrderDetailsToJSON,
} from './TenantOrderDetails';
import type { TermsConditions } from './TermsConditions';
import {
    TermsConditionsFromJSON,
    TermsConditionsFromJSONTyped,
    TermsConditionsToJSON,
} from './TermsConditions';

/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Order
     */
    orderDate: Date;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    orderNumber?: number;
    /**
     * 
     * @type {CustomerShort}
     * @memberof Order
     */
    customer?: CustomerShort;
    /**
     * 
     * @type {Address}
     * @memberof Order
     */
    invoiceAddress: Address;
    /**
     * 
     * @type {Address}
     * @memberof Order
     */
    shippingAddress: Address;
    /**
     * 
     * @type {TermsConditions}
     * @memberof Order
     */
    termsConditions: TermsConditions;
    /**
     * 
     * @type {Cart}
     * @memberof Order
     */
    cart?: Cart;
    /**
     * 
     * @type {Invoice}
     * @memberof Order
     */
    invoice?: Invoice;
    /**
     * 
     * @type {Invoice}
     * @memberof Order
     */
    latestRecurringInvoice?: Invoice;
    /**
     * 
     * @type {TenantOrderDetails}
     * @memberof Order
     */
    tenantDetails?: TenantOrderDetails;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    refundId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    subscription?: boolean;
    /**
     * 
     * @type {OrderStatus}
     * @memberof Order
     */
    status?: OrderStatus;
}

/**
 * Check if a given object implements the Order interface.
 */
export function instanceOfOrder(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "orderDate" in value;
    isInstance = isInstance && "invoiceAddress" in value;
    isInstance = isInstance && "shippingAddress" in value;
    isInstance = isInstance && "termsConditions" in value;

    return isInstance;
}

export function OrderFromJSON(json: any): Order {
    return OrderFromJSONTyped(json, false);
}

export function OrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): Order {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'orderDate': (new Date(json['orderDate'])),
        'orderNumber': !exists(json, 'orderNumber') ? undefined : json['orderNumber'],
        'customer': !exists(json, 'customer') ? undefined : CustomerShortFromJSON(json['customer']),
        'invoiceAddress': AddressFromJSON(json['invoiceAddress']),
        'shippingAddress': AddressFromJSON(json['shippingAddress']),
        'termsConditions': TermsConditionsFromJSON(json['termsConditions']),
        'cart': !exists(json, 'cart') ? undefined : CartFromJSON(json['cart']),
        'invoice': !exists(json, 'invoice') ? undefined : InvoiceFromJSON(json['invoice']),
        'latestRecurringInvoice': !exists(json, 'latestRecurringInvoice') ? undefined : InvoiceFromJSON(json['latestRecurringInvoice']),
        'tenantDetails': !exists(json, 'tenantDetails') ? undefined : TenantOrderDetailsFromJSON(json['tenantDetails']),
        'refundId': !exists(json, 'refundId') ? undefined : json['refundId'],
        'subscription': !exists(json, 'subscription') ? undefined : json['subscription'],
        'status': !exists(json, 'status') ? undefined : OrderStatusFromJSON(json['status']),
    };
}

export function OrderToJSON(value?: Order | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'orderDate': (value.orderDate.toISOString()),
        'orderNumber': value.orderNumber,
        'customer': CustomerShortToJSON(value.customer),
        'invoiceAddress': AddressToJSON(value.invoiceAddress),
        'shippingAddress': AddressToJSON(value.shippingAddress),
        'termsConditions': TermsConditionsToJSON(value.termsConditions),
        'cart': CartToJSON(value.cart),
        'invoice': InvoiceToJSON(value.invoice),
        'latestRecurringInvoice': InvoiceToJSON(value.latestRecurringInvoice),
        'tenantDetails': TenantOrderDetailsToJSON(value.tenantDetails),
        'refundId': value.refundId,
        'subscription': value.subscription,
        'status': OrderStatusToJSON(value.status),
    };
}

